import React, { useEffect, useState } from "react";
import "./NavBar.css";

export default function NavBar() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  // bloque le scroll quand menu mobile ouvert
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => (document.body.style.overflow = "");
  }, [open]);

  return (
    <>
      {/* NAV FIXE */}
      <nav className="navbarWrap-nvt">
        <div className="navbarInner-nvt">
          {/* Left: Logo */}
          <a className="brand-nvt" href="/">
            <span className="brandMark-nvt" aria-hidden="true">
              <img
                src="/logo.png" // chemin vers ton image
                alt=""                        // vide si décoratif
                width={50}
                height={50}
              />
            </span>
            <span className="brandText-nvt">WELTOC</span>
          </a>

          {/* Center: Links (desktop) */}
          <div className="links-nvt" role="navigation" aria-label="Primary">
            <a className="link-nvt" href="/">
              Sites Vitrines
            </a>
            <a className="link-nvt" href="/">
              Sites Ecommerce
            </a>
            <a className="link-nvt" href="/">
              Gestion de Stock
            </a>
            <a className="link-nvt" href="/">
              Catalogues de Produits
            </a>
            <a className="link-nvt" href="/">
              Gestion de Livraisons
            </a>
            <a className="link-nvt" href="/">
              Nos Tarifs
            </a>
          </div>

          {/* Right: Icons + hamburger */}
          <div className="actions-nvt">
           <a className="iconBtn-nvt" href="https://wa.me/+22893410827" style={{textDecoration: 'none'}}>
            <svg
              viewBox="0 0 24 24"
              width="18"
              height="18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M4 20a8 8 0 0 1 16 0"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M16 6h3v3"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>

            <span style={{ marginLeft: "8px" }}>
              Prendre rendez-vous
            </span>
          </a>


           

            <button
              className="hamburger-nvt"
              aria-label="Open menu"
              aria-expanded={open}
              onClick={() => setOpen(true)}
            >
              <span className="hamburgerLine-nvt" />
              <span className="hamburgerLine-nvt" />
              <span className="hamburgerLine-nvt" />
            </button>
          </div>
        </div>
      </nav>

      {/* Spacer pour que le contenu passe en dessous du nav fixe */}
      <div className="navbarSpacer-nvt" aria-hidden="true" />

      {/* Mobile Drawer */}
      <div
        className={`overlay-nvt ${open ? "overlayOpen-nvt" : ""}`}
        onClick={() => setOpen(false)}
      />

      <aside className={`drawer-nvt ${open ? "drawerOpen-nvt" : ""}`}>
        <div className="drawerTop-nvt">
          <span className="drawerTitle-nvt">Menu</span>
          <button className="closeBtn-nvt" onClick={() => setOpen(false)} aria-label="Close menu">
            ✕
          </button>
        </div>

        <nav className="drawerLinks-nvt" aria-label="Mobile navigation">
          <a className="drawerLink-nvt" href="/" onClick={() => setOpen(false)}>
            Sites Vitrines
          </a>
          <a className="drawerLink-nvt" href="/" onClick={() => setOpen(false)}>
            Sites Ecommerce
          </a>
          <a className="drawerLink-nvt" href="/" onClick={() => setOpen(false)}>
            Gestion de Stock
          </a>
          <a className="drawerLink-nvt" href="/" onClick={() => setOpen(false)}>
            Catalogues de Produits
          </a>
          <a className="drawerLink-nvt" href="/" onClick={() => setOpen(false)}>
            Gestion de Livraisons
          </a>
          <a className="drawerLink-nvt" href="/" onClick={() => setOpen(false)}>
            Nos Tarifs
          </a>
        </nav>
      </aside>
    </>
  );
}
